import getId from './getId'

const getColumnId = () => {
  return `c_${getId()}`
}

export default getColumnId
